import { getFaiOffersByCategory } from '@services/categories';
import { faiService } from '@services/fai';

import { SapicCategoryId, SapicFundingMode } from '@app-types/api/sapic';
import { FaiType, OffersByCategoryCode } from '@app-types/plan';

import { PlanTypeId } from '@constants/plan';

export type FaiProductsCharacteristicsType = Awaited<ReturnType<FaiComparatorService['getProductsCharacteristics']>>;

class FaiComparatorService {
    public async getProductsCharacteristics() {
        const categoriesOrder = [
            PlanTypeId.FAI_BOX_INTERNET,
            PlanTypeId.FAI_PUREBYOU,
            PlanTypeId.FAI_5GBOX,
            PlanTypeId.FAI_ELIGIBILITE,
        ];

        return Promise.all([this.getCategories(categoriesOrder), this.getAllOffers()]).then((params) =>
            this.offerSelector(categoriesOrder, params[0].offersByCategoryCode, params[1]),
        );
    }

    private async getAllOffers() {
        return faiService.getOffers(
            {
                fundingMode: SapicFundingMode.NONE,
                limit: -1,
                filterByTypes: [SapicCategoryId.FAI, SapicCategoryId.FAIM_UNLIMITED],
            },
            undefined,
            true,
        );
    }

    private async getCategories(categories: PlanTypeId[]) {
        return getFaiOffersByCategory(categories);
    }

    private async offerSelector(
        categoriesOrder: PlanTypeId[],
        offersByCategory: OffersByCategoryCode,
        offers: FaiType[],
    ) {
        return categoriesOrder
            .map((category) => offersByCategory[category] ?? [])
            .flat()
            .reduce((acc, { rangeNg, commercialSeries, technology }) => {
                if (
                    acc.some(
                        (existing) =>
                            existing.rangeNg === rangeNg &&
                            existing.commercialSeries === commercialSeries &&
                            existing.technology === technology,
                    )
                ) {
                    return acc;
                }
                const offer = offers.find(
                    (offer) =>
                        offer.rangeNg === rangeNg &&
                        offer.commercialSeries === commercialSeries &&
                        offer.technology === technology,
                );

                if (offer) {
                    acc.push(offer);
                }

                return acc;
            }, [] as FaiType[]);
    }
}

export const faiComparatorService = new FaiComparatorService();
